import { createStore } from 'helpers/state';
var sizeStore = createStore({
    notificationHeight: 0,
    headerHeight: 0,
    headerBottom: 0
});
export default sizeStore;
